<template>
  <div id="alarmList" style="width: 100%">
    <div class="page-header">
      <div class="page-title">报警列表</div>
      <div class="page-header-btn">
        设备:
        <el-select v-model="deviceId" filterable remote reserve-keyword placeholder="输入关键字搜索设备"
          :remote-method="searchDevices" :loading="deviceLoading" @change="initData"
          style="width: 12rem; margin-right: 1rem;" size="mini" clearable>
          <el-option v-for="item in deviceOptions" :key="item.deviceId" :label="item.name" :value="item.deviceId">
          </el-option>
        </el-select>
        报警级别:
        <el-select size="mini" style="width: 8rem; margin-right: 1rem;" @change="initData" v-model="alarmPriority"
          placeholder="报警级别" clearable>
          <el-option label="一级警情" value="1"></el-option>
          <el-option label="二级警情" value="2"></el-option>
          <el-option label="三级警情" value="3"></el-option>
          <el-option label="四级警情" value="4"></el-option>
        </el-select>
        报警方式:
        <el-select size="mini" style="width: 8rem; margin-right: 1rem;" @change="initData" v-model="alarmMethod"
          placeholder="报警方式" clearable>
          <el-option label="电话报警" value="1"></el-option>
          <el-option label="设备报警" value="2"></el-option>
          <el-option label="短信报警" value="3"></el-option>
          <el-option label="GPS报警" value="4"></el-option>
          <el-option label="视频报警" value="5"></el-option>
          <el-option label="设备故障报警" value="6"></el-option>
          <el-option label="其他报警" value="7"></el-option>
        </el-select>
        报警类型:
        <el-select size="mini" style="width: 10rem; margin-right: 1rem;" @change="initData" v-model="alarmType"
          placeholder="报警类型" clearable>
          <el-option label="视频丢失报警" value="1"></el-option>
          <el-option label="设备防拆报警" value="2"></el-option>
          <el-option label="存储设备磁盘满报警" value="3"></el-option>
          <el-option label="设备高温报警" value="4"></el-option>
          <el-option label="设备低温报警" value="5"></el-option>
        </el-select>
        时间范围:
        <el-date-picker v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
          end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" @change="initData" size="mini"
          style="margin-right: 1rem;">
        </el-date-picker>
        <el-button icon="el-icon-refresh-right" circle size="mini" :loading="loading" @click="getAlarmList()"></el-button>
      </div>
    </div>
    <!--报警列表-->
    <el-table size="medium" :data="alarmList" style="width: 100%;font-size: 12px;" :height="$tableHeght"
      header-row-class-name="table-header" v-loading="loading">
      <el-table-column prop="deviceName" label="设备名称" min-width="160"></el-table-column>
      <el-table-column prop="channelName" label="通道ID" min-width="160"></el-table-column>
      <el-table-column prop="alarmPriorityDescription" label="报警级别" min-width="100"></el-table-column>
      <el-table-column prop="alarmMethodDescription" label="报警方式" min-width="160"></el-table-column>
      <el-table-column prop="alarmTypeDescription" label="报警类型" min-width="160"></el-table-column>
      <el-table-column prop="alarmTime" label="报警时间" min-width="160"></el-table-column>
      <el-table-column prop="alarmDescription" label="报警描述" min-width="200"></el-table-column>
      <el-table-column label="抓拍" min-width="120">
        <template v-slot:default="scope">
          <img v-if="scope.row.snapFilename" class="alarm-snap-thumb" :src="getSnapSrc(scope.row)"
            @click="openSnapDialog(scope.row)" @error="onSnapImgError(scope.row)" />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="位置信息" min-width="200">
        <template v-slot:default="scope">
          <span>经度: {{ scope.row.longitude }}, 纬度: {{ scope.row.latitude }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="操作" width="100" fixed="right">
        <template v-slot:default="scope">
          <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteAlarm(scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination style="float: right;margin-top: 1rem;" @size-change="handleSizeChange"
      @current-change="currentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="count"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>

    <el-dialog :visible.sync="snapDialogVisible" :title="snapDialogTitle" width="60%">
      <div style="text-align: center;">
        <img v-if="snapDialogSrc" class="alarm-snap-full" :src="snapDialogSrc" />
        <div v-else>无抓拍图片</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'

export default {
  name: 'alarmList',
  data() {
    return {
      alarmList: [], // 报警列表
      loading: false,
      currentPage: 1,
      count: 10,
      total: 0,
      deviceId: null,
      deviceOptions: [], // 设备选项列表
      deviceLoading: false, // 设备加载状态
      alarmPriority: null,
      alarmMethod: null,
      alarmType: null,
      timeRange: null,
      startTime: null,
      endTime: null,
      snapDialogVisible: false,
      snapDialogSrc: '',
      snapDialogTitle: ''
    }
  },
  created() {
    this.initData();
  },
  methods: {
    getSnapSrc(row) {
      if (!row || !row.snapFilename) {
        return '';
      }
      return row.snapFilename;
    },
    openSnapDialog(row) {
      this.snapDialogTitle = `报警抓拍 - ${row && row.deviceName ? row.deviceName : ''}`.trim();
      this.snapDialogSrc = this.getSnapSrc(row);
      this.snapDialogVisible = true;
    },
    onSnapImgError(row) {
      console.info('抓拍图片加载失败', row);
      // this.$message.warning('抓拍图片加载失败');
    },
    initData() {
      this.currentPage = 1;
      this.getAlarmList();
    },
    // 根据关键字搜索设备
    searchDevices(query) {
      if (query !== '') {
        this.deviceLoading = true;
        axios({
          method: 'get',
          url: '/api/device/query/devices',
          params: {
            page: 1,
            count: 50,
            query: query
          }
        }).then(res => {
          if (res.data && res.data.data && res.data.data.list) {
            this.deviceOptions = res.data.data.list;
          } else {
            this.deviceOptions = [];
          }
          this.deviceLoading = false;
        }).catch(error => {
          console.error(error);
          this.deviceOptions = [];
          this.deviceLoading = false;
        });
      } else {
        this.deviceOptions = [];
      }
    },
    getAlarmList() {
      this.loading = true;

      // 处理时间范围
      if (this.timeRange && this.timeRange.length === 2) {
        this.startTime = this.timeRange[0];
        this.endTime = this.timeRange[1];
      } else {
        this.startTime = null;
        this.endTime = null;
      }

      axios({
        method: 'get',
        url: '/api/alarm/all',
        params: {
          page: this.currentPage,
          count: this.count,
          deviceId: this.deviceId,
          alarmPriority: this.alarmPriority,
          alarmMethod: this.alarmMethod,
          alarmType: this.alarmType,
          startTime: this.startTime,
          endTime: this.endTime
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.alarmList = res.data.data.list;
          this.total = res.data.data.total;
        } else {
          this.$message.error(res.data.msg);
        }
        this.loading = false;
      }).catch(error => {
        console.error(error);
        this.$message.error('获取报警列表失败');
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.count = val;
      this.getAlarmList();
    },
    currentChange(val) {
      this.currentPage = val;
      this.getAlarmList();
    },
    deleteAlarm(row) {
      this.$confirm('确认删除该报警记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios({
          method: 'delete',
          url: '/api/alarm/delete',
          params: {
            id: row.id
          }
        }).then(res => {
          if (res.data.code === 0) {
            this.$message.success('删除成功');
            this.getAlarmList();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          console.error(error);
          this.$message.error('删除失败');
        });
      }).catch(() => {
        // 取消删除
      });
    }
  }
}
</script>

<style>
.alarm-snap-thumb {
  width: 80px;
  height: 45px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 2px;
  border: 1px solid #eee;
}

.alarm-snap-full {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/AlarmList.vue